import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fb2d350"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "button-container"
}
const _hoisted_2 = { class: "highscore" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Best: ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delete highscore", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    headline: "Help",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.gameHelperComponent))),
      _createVNode(_Transition, { name: "fadeaway" }, {
        default: _withCtx(() => [
          (_ctx.hasHighscore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.extraPointsClasses)
                  }, [
                    _createTextVNode(_toDisplayString(this.currentHighscore), 1),
                    (_ctx.isTimeScore)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "s"))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _createElementVNode("button", {
                  class: "hs-delete-button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteHighscore && _ctx.deleteHighscore(...args)))
                }, [
                  _createVNode(_component_svg_icon, {
                    icon: "trash",
                    size: 0.8,
                    class: "m02-right"
                  }, null, 8, ["size"]),
                  _hoisted_5
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}